import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const SchoolBell = (props: Icon): React.ReactElement => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ ...style(props.size, props.height), ...props.style }}
  >
    <defs>
      <path
        d="M6 17.333a.667.667 0 01-.596-.964l1.105-2.212a7.797 7.797 0 00.824-3.49l.003-.16a4.668 4.668 0 012.713-4.08A1.85 1.85 0 0110 6a2 2 0 113.953.428 4.663 4.663 0 012.714 4.239l.004.26a7.797 7.797 0 00.82 3.23l1.105 2.212a.667.667 0 01-.596.964h-3.333a2.667 2.667 0 11-5.334 0zm4.667 0a1.333 1.333 0 102.666 0h-2.666zm1.333-10c-.284 0-.56.036-.824.103a.51.51 0 01-.113.032 3.332 3.332 0 00-2.396 3.199l-.005.283a9.129 9.129 0 01-.96 3.803L7.078 16h9.843l-.622-1.246a9.13 9.13 0 01-.961-3.804l-.008-.428a3.335 3.335 0 00-2.392-3.055.554.554 0 01-.114-.029A3.233 3.233 0 0012 7.333zm0-2a.666.666 0 00-.667.667l.003.047a4.707 4.707 0 011.327 0L12.667 6A.666.666 0 0012 5.333z"
        id="prefix__a-school-bell"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="prefix__b-school-bell" fill="#fff">
        <use xlinkHref="#prefix__a-school-bell" />
      </mask>
      <use fill="#FFF" fillRule="nonzero" xlinkHref="#prefix__a-school-bell" />
      <g
        mask="url(#prefix__b-school-bell)"
        fill={props.color || theme.palette.grey600}
      >
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
);
